module.exports = __webpack_public_path__ + "img/private_icon.58e68a65.png";